import { join } from 'light-component';
import { Struct } from 'shoteyes-types';
import { Block, Box, Icons, useTranslation } from '@common';
import * as Base from '@base';
import { Highlighter } from '../../component';
import styles from '../style.module.less';
import { RadioBoxComponent } from './radio';
import type { ReactElement } from 'react';
import type { RadioBoxProps } from './types';

export function RadioBoxViewMode(props: RadioBoxProps): ReactElement {
  const [t] = useTranslation();
  if (props?.formType === Struct.FormType.ANSWER) {
    return (
      <Box className={styles.viewBox}>
        <Box className={join(styles.subject, styles.input)}>
          <Block if={props.ok != null}>
            {props.ok === true
              ? <Icons name='CheckOutlined' style={{ color: '#77C06E' }} />
              : <Icons name='CloseOutlined' style={{ color: '#F47F7F' }} />
            }
          </Block>
          <Block if={props.number != null}>{props.number}、</Block>
          <Block if={props.typeName != null}>
            <Base.Tag color='#ff943f'>{props.typeName}</Base.Tag>
          </Block>
          <Highlighter
            title={props.title}
            keyword={props.keyword}
            className={styles.title}
          />

          <Block if={props.realScore != null && props.score != null}>
            <span className={styles.score} style={{ color: props.ok === true ? 'inherit' : '#f47f7f' }}>
              {`(${props.realScore}/${props.score})`}
            </span>
          </Block>
        </Box>
        <Box className={join(styles.viewContent, styles.inputContent, styles.answerBox)}>
          <RadioBoxComponent {...props} />
          <div className={styles.mb10}>
            {t('提交答案{answer}', { answer: props.value })}
          </div>
          <div className={styles.mb10}>
            {t('正确{answer}', { answer: props.answer })}
          </div>
          <Block if={props.specification != null && props.specification?.length > 0}>
            <div>{t('答案解析')}：</div>
            <div
              // 保留原有样式，不使用module
              className='ql-editors no-border'
              data-gramm='false'
              dangerouslySetInnerHTML={{ __html: props.specification ?? '' }}
            />
          </Block>
        </Box>
      </Box>);
  }
  return (
    <Box className={styles.viewBox}>
      <Box className={join(styles.subject, styles.input)}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
      <Box className={join(styles.content, styles.inputContent)}>
        <RadioBoxComponent {...props} />
      </Box>
    </Box>
  );
}
